import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSignOut } from '@hooks/use-sign-out.ts';

export function AuthLogoutPage() {
  const navigate = useNavigate();
  const signOut = useSignOut();

  useEffect(() => {
    signOut();
    navigate('/auth');
  }, [signOut, navigate]);

  return null;
}
